
import { Component, Mixins } from "vue-property-decorator";
import { ILineDrawable } from "../../../../../domain/document/items";
import { Size, Rectangle, LineStyle, LineKinds } from "../../../../../domain/drawing";

@Component({
})
export default class LineDrawableMixin extends Mixins() {
  readPropertyOrDefault: <T>(reader: (source: ILineDrawable) => T, defaultValue: T) => T;
  rectangle: Rectangle;

  get lineStyle(): LineStyle {
    return this.readPropertyOrDefault(s => s.lineStyle, null);
  }

  get lineStyleProperties() {
    return {
      fill: "none",           // none.(transparentだと描画はされるため、pointerEvents対象になってしまう.)
      stroke: this.lineStyle.color.value,
      strokeWidth: this.lineStyle.width,
      strokeDasharray: (this.lineStyle.kind === LineKinds.Dotted) ? "3" : "0",
      pointerEvents: "visiblePainted",
      opacity: this.lineStyle.opacity,
    };
  }

  get draggableLineStyleProperties() {
    return {
      fill: "none",           // none.(transparentだと描画はされるため、pointerEvents対象になってしまう.)
      stroke: "transparent",  // transparentで描画する事で、pointerEvents対象とする.)
      strokeWidth: this.draggableStrokeWidth,
      strokeDasharray: (this.lineStyle.kind === LineKinds.Dotted) ? "3" : "0",
      pointerEvents: "visiblePainted",
    };
  }

  get draggableStrokeWidth(): number {
    return Math.max(this.lineStyle.width, 4);
  }

  get drawerRectangle(): Rectangle {
    return new Rectangle(
      this.rectangle.topLeft,
      new Size(Math.max(this.rectangle.width, 1), Math.max(this.rectangle.height, 1)));
  }

  get drawerStyleProperties() {
    return {
      position: "absolute",
      top: this.drawerRectangle.x + "px",
      left: this.drawerRectangle.y + "px",
      width: this.drawerRectangle.width + "px",
      height: this.drawerRectangle.height + "px",
    };
  }

  get isDouble(): boolean {
    return this.lineStyle.kind === LineKinds.Double;
  }
}
